@if (versionValid && loaded) {
  <router-outlet></router-outlet>
}
